<template>
  <div class="wrapper">
    <navbars />
    <sidebar />
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">{{page_name}}</h1>
            </div>
            <!-- /.col -->
            <!-- <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item active">Dashboard v1</li>
                </ol>
            </div> -->
            <!-- /.col -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
      </div>
      <app-main />
    </div>
    <footers />
  </div>
</template>

<script>
import { Navbars, AppMain, Sidebar, Footers } from './components'
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  components: {
    Navbars,
    AppMain,
    Sidebar,
    Footers,
  },
  computed: {
      ...mapGetters([
          'page_name'
      ])
  },
  methods: {

  }
}
</script>

